<script setup>
import { router } from '@inertiajs/vue3'
import TextInput from '@/Shared/TextInput.vue'
import TextareaInput from '@/Shared/TextareaInput.vue'
import LoadingButton from '@/Shared/LoadingButton.vue'
import { useForm } from '@inertiajs/vue3'
import { useConfirm } from '@/Composables/useConfirm'
import Portrait from '@/Shared/Portrait.vue'

const props = defineProps({
  level: {
    type: Object,
    required: true
  }
})

let form = useForm({
  name: props.level.name,
  description: props.level.description,
  order: props.level.order,
  color: props.level.color
})

function update() {
  form.put(`/lessons/levels/${props.level.id}/update`)
}

async function deleteLevel() {
  if (await useConfirm('¿Estas seguro de que quieres eliminar el nivel?')) {
    router.delete(`/lessons/levels/${props.level.id}/delete`)
  }
}

const breadcrumbs = [
  { label: 'Clases' },
  { label: 'Niveles', href: '/lessons/levels' },
  { label: props.level.name }
]
</script>

<template>
  <Portrait
    :title="`Nivel: ${form.name}`"
    subtitle="Gestiona la información del nivel"
    :breadcrumbs="breadcrumbs"
    :footer-actions="true"
  >
    <div class="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden p-6">
      <div class="flex items-center mb-6 pb-4 border-b border-gray-100">
        <div
          class="h-16 w-16 rounded-full flex items-center justify-center text-white font-bold mr-4"
          :style="`background-color: ${form.color};`"
        >
          {{ form.order }}
        </div>
        <div>
          <h3 class="text-lg font-medium text-gray-900">{{ form.name }}</h3>
          <p class="text-sm text-gray-500">{{ form.description }}</p>
        </div>
      </div>

      <form class="space-y-6" @submit.prevent="update">
        <div class="grid grid-cols-1 gap-6">
          <TextInput
            v-model="form.name"
            :error="form.errors.name"
            label="Nombre"
            class="md:col-span-3"
          />
          <TextInput
            v-model="form.color"
            :error="form.errors.color"
            type="color"
            label="Color"
            class="md:col-span-1"
          />
          <TextareaInput
            v-model="form.description"
            :error="form.errors.description"
            class="md:col-span-4"
            label="Descripción"
          />
        </div>
      </form>
    </div>

    <template #footer>
      <!-- Versión móvil -->
      <div class="w-full block sm:hidden">
        <div class="flex items-stretch justify-end w-full space-x-4">
          <button class="btn-red" type="button" @click="deleteLevel">Eliminar</button>

          <LoadingButton
            :loading="form.processing"
            class="btn-indigo"
            type="submit"
            @click="update"
          >
            Guardar
          </LoadingButton>
        </div>
      </div>

      <!-- Versión escritorio -->
      <div class="hidden sm:flex sm:items-center sm:justify-end w-full space-x-4">
        <button class="btn-red" type="button" @click="deleteLevel">Eliminar</button>

        <LoadingButton :loading="form.processing" class="btn-indigo" type="submit" @click="update">
          Guardar
        </LoadingButton>
      </div>
    </template>
  </Portrait>
</template>
